"use client";

import { usePathname } from "next/navigation";
import Script from "next/script";
import {useContext, useEffect, useState} from "react";
import {Basket} from "../../context/basket";

const TiktokPixel = () => {
    const basket = useContext(Basket);
    const [loaded, setLoaded] = useState(false);
    const [hasInit, setHasInit] = useState(false);
    const pathname = usePathname();
    const setLoadedState = () => {
        if (loaded === false) {
            setLoaded(true);
        }
    }

    useEffect(() => {
        if (!loaded) return;
        if (typeof ttq !== 'undefined') {
            if (!hasInit && typeof basket?.data?.customer !== 'undefined') {
                //ttq.load('CES24JJC77UA35R5ENI0');
                //ttq.page();
            }
        }
    }, [pathname, loaded, basket]);

    return (
        <div>
            {/*<Script*/}
            {/*    id="tiktok-pixel"*/}
            {/*    src="/static/scripts/tiktok_pixel.js"*/}
            {/*    strategy="lazyOnload"*/}
            {/*    onLoad={() => setLoadedState()}*/}
            {/*/>*/}
        </div>
    );
};

export default TiktokPixel;